import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco, provideTranslocoMissingHandler } from '@jsverse/transloco';
import { MissingTranslationHandler, translateConfig, TranslateJsonLoder } from '../configuration/translate.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes,withHashLocation()), provideHttpClient(), provideTransloco({
        config: { 
          availableLangs: ['en'],
          defaultLang: 'en',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      }),
    provideTransloco({
      loader: TranslateJsonLoder,
      config: translateConfig
    }),
    provideTranslocoMissingHandler(MissingTranslationHandler),
    provideRouter(routes, withHashLocation())
  ]
};
